import Route from './components/Route'
import { AuthContext } from './context/AuthContext';

function App() {
  return (
    <div className="App">
    
      <Route/>
     
    </div>
  );
}

export default App;
